import I18n from 'I18n';
import getLangLocale from 'I18n/utils/getLangLocale';
import { useQuery } from 'data-fetching-client';
import { GET_BUSINESS_OBJECTIVES } from 'pricing-pages-api/business-objectives/queries';
import { useSetOneGlobalLoadingState } from '../context/GlobalLoadingStateContext';
export const useBusinessObjectivesForApiNames = ({
  highlightedProducts,
  highlightedFeatureType
}) => {
  // @ts-expect-error dependency missing types
  const langLocale = I18n.loaded && I18n.locale ? getLangLocale() : 'en-us';
  const onCompletedCallback = useSetOneGlobalLoadingState('BusinessObjectives');
  const queryResult = useQuery(GET_BUSINESS_OBJECTIVES, {
    variables: {
      highlightedProducts,
      highlightedFeatureType,
      langLocale
    },
    skip: !highlightedProducts.length,
    onCompleted: onCompletedCallback
  });
  const {
    data,
    loading
  } = queryResult;
  return {
    businessObjectives: (data === null || data === void 0 ? void 0 : data.businessObjectives) || [],
    loading
  };
};